import { TicketStatus } from '@navio/nsdk';
import { noddiAsync, URLKeys } from 'noddi-async';
import { useAuthContext } from '../../../contexts/useAuthContext';

const THIRTY_MINUTES_IN_MS = 30 * 60 * 1000;

const ACTIVE_STATUSES: TicketStatus[] = [TicketStatus.OPEN, TicketStatus.SNOOZED];

type Props = {
  serviceOrganizationIds?: number[];
  serviceDepartmentIds?: number[];
};

export const useMyTicketsCount = ({ serviceOrganizationIds, serviceDepartmentIds }: Props) => {
  const { currentUserGroupId } = useAuthContext();

  const { data, isLoading, error } = noddiAsync.useGet({
    type: URLKeys.getPaginatedTickets,
    input: {
      pageSize: 1,
      statuses: ACTIVE_STATUSES,
      assigneeIds: currentUserGroupId ? [currentUserGroupId] : [],
      serviceOrganizationIds,
      serviceDepartmentIds
    },
    queryConfig: {
      staleTime: THIRTY_MINUTES_IN_MS,
      refetchInterval: THIRTY_MINUTES_IN_MS,
      refetchIntervalInBackground: true,
      enabled: !!currentUserGroupId
    }
  });

  return {
    isLoading,
    error,
    count: currentUserGroupId ? (data?.count ?? 0) : 0
  };
};
